/**
 * STOPFLEX theme-editor-safe localization.
 * Keeps each language selector scoped to its own Shopify localization form.
 * Prevents localization/currency navigation inside Shopify design mode.
 */
(function () {
  'use strict';

  if (window.__stopflexLocalizationInitialized) return;
  window.__stopflexLocalizationInitialized = true;

  var LANGUAGE_ITEM = '[data-sfx-locale-item]';
  var LEGACY_EDITOR_ITEM = '[data-locale-item], [data-currency-item]';

  function isDesignMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function closest(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function updateSelectorPreview(item, form) {
    var wrap = closest(item, '[data-locale-wrap]');
    if (!wrap) return;

    var previous = wrap.querySelector('.is--selected');
    var current = wrap.querySelector('[data-current]');
    var code = item.getAttribute('data-iso') || '';
    var label = item.getAttribute('data-language') || code;
    var input = form.querySelector('[name="language_code"]');

    if (previous) {
      previous.classList.remove('is--selected');
      previous.removeAttribute('aria-current');
    }
    item.classList.add('is--selected');
    item.setAttribute('aria-current', 'true');
    if (input) input.value = code;

    if (current) {
      var oldCode = current.getAttribute('data-sfx-current-code') || '';
      if (!oldCode) {
        var classMatch = current.className.match(/flagst4s-([^\s]+)/);
        oldCode = classMatch ? classMatch[1] : '';
      }
      if (oldCode) current.classList.remove('flagst4s-' + oldCode);
      if (code) current.classList.add('flagst4s-' + code);
      current.setAttribute('data-sfx-current-code', code);
      current.textContent = wrap.getAttribute('data-sfx-label-mode') === 'short' ? code.toUpperCase() : label;
    }
  }

  document.addEventListener('click', function (event) {
    var item = closest(event.target, LANGUAGE_ITEM);
    if (item) {
      event.preventDefault();

      var form = closest(item, 'form.t4s-sfx-localization-form, form.t4s-sfx-mobile-locale-form');
      var input = form ? form.querySelector('[name="language_code"]') : null;
      var code = item.getAttribute('data-iso');

      if (!form || !input || !code || item.classList.contains('is--selected')) return;

      input.value = code;
      if (isDesignMode()) {
        updateSelectorPreview(item, form);
        return;
      }

      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
      return;
    }

    if (isDesignMode() && closest(event.target, LEGACY_EDITOR_ITEM)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (!isDesignMode()) return;
    var form = event.target;
    if (form && form.matches && form.matches('form[action*="/localization"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('shopify:section:unload', function (event) {
    var openDropdowns = event.target.querySelectorAll('[data-dropdown-wrapper].is--opend');
    for (var i = 0; i < openDropdowns.length; i += 1) {
      openDropdowns[i].classList.remove('is--opend');
    }
  });
}());
